import { withTranslation } from 'react-i18next';
import type { FormikValues } from 'formik';
import { withFormik } from 'formik';
import { object, string } from 'yup';

import { get, transformApiErrors } from 'src/helper/helper';
import { apiPaths } from 'src/services/api/apiPaths';
import HttpService from 'src/services/api/http';

import type { PasswordResetFormValues } from '../PasswordResetForm';
import PasswordResetForm from '../PasswordResetForm';

const validationSchema = ({ t }: { t: (arg0: string) => string }) =>
  object().shape({
    email: string().required(t('emailMissing')).email(t('emailWrongFormat')),
  });

export const handleSubmit = (
  { email }: PasswordResetFormValues,
  { setSubmitting, setErrors, props }: FormikValues,
) => {
  setSubmitting(true);
  return HttpService.post(apiPaths.ACCOUNT.PASSWORD_RESET, { email })
    .then(() => {
      props.onDone(); // Now we tell the outer component, that we are done.
    })
    .catch((error) => {
      setErrors(transformApiErrors(get(() => error.response.data)));
      return false;
    })
    .finally(() => {
      setSubmitting(false);
    });
};

interface PasswordResetFormProps {
  onDone: () => void;
}

const PasswordResetFormContainer = withFormik<
  PasswordResetFormProps,
  PasswordResetFormValues
>({
  mapPropsToValues: () => ({ email: '' }),
  validationSchema,
  handleSubmit,
})(PasswordResetForm);

export default withTranslation('login')(PasswordResetFormContainer);
